import o from"react";var p=({variant:s="primary",children:n,label:e,icon:t,className:r="","data-id":a,...i})=>o.createElement("button",{className:`
        px-6 py-3 rounded-xl text-white
        bg-[#0044FF] hover:bg-[#0036CC] 
        transition-colors duration-200
        inline-flex items-center gap-2
        text-base font-semibold font-['Manrope']
        shadow-[0_4px_12px_rgba(0,68,255,0.25)]
        ${r}
      `,"data-id":a,...i},t&&o.createElement(t,{className:"w-4 h-4"}),e||n);export{p as Button};
//# sourceMappingURL=index.js.map
